import { render, staticRenderFns } from "./Chatbox.vue?vue&type=template&id=0584f4ec&scoped=true&"
import script from "./Chatbox.vue?vue&type=script&lang=js&"
export * from "./Chatbox.vue?vue&type=script&lang=js&"
import style0 from "./Chatbox.vue?vue&type=style&index=0&id=0584f4ec&lang=scss&scoped=true&"
import style1 from "./Chatbox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0584f4ec",
  null
  
)

export default component.exports